import { useState } from 'react';

interface DebugToolModalButtonProps {
    header? : string,
    children?: React.ReactNode
}
function DebugToolModalButton ({ children, header }: DebugToolModalButtonProps) {
    const [DebugToolModalButtonVisible, setDebugToolModalButtonVisible] = useState(false)

    const onOpenModal = () => {
        setDebugToolModalButtonVisible(true)
    }
    const onCloseModal = () => {
        setDebugToolModalButtonVisible(false)
    }

    return (
       <>
            <button className="btn orange large debug" onClick={() => onOpenModal()}>Debug Tool</button>
            <div className={`modal-wrapper ${DebugToolModalButtonVisible ? 'modal-visible': 'modal-hidden'}`}>
                <div className="modal">
                    <div className="modal-header">
                        <span className="header clickable" onClick={() => onCloseModal()}>&larr;</span>
                        <span className="header">{ header }</span>
                    </div>
                    <div className='modal-body'>
                        { children }
                    </div>
                </div>
            </div>
       </>
   )
}

export default DebugToolModalButton